var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.items.length==1)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.items[0][_vm.language])}}):_vm._l((_vm.items),function(item,index){return _c('ul',{key:`item-${index}`},[((typeof item=='object'))?_c('List',{attrs:{"items":item,"language":_vm.language}}):_c('li',[_c('span',{domProps:{"innerHTML":_vm._s(item)}})])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }